import { render, staticRenderFns } from "./icon-rounded-object.vue?vue&type=template&id=449b5295&scoped=true&"
import script from "./icon-rounded-object.vue?vue&type=script&lang=js&"
export * from "./icon-rounded-object.vue?vue&type=script&lang=js&"
import style0 from "./icon-rounded-object.vue?vue&type=style&index=0&id=449b5295&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449b5295",
  null
  
)

export default component.exports